"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const GuidesButton_1 = __importDefault(require("../../../atoms/GuidesButton"));
const PenOptions_1 = __importDefault(require("../../../molecules/PenOptions"));
const PenTypesPanel_1 = __importDefault(require("../../../molecules/PenTypesPanel"));
const ToolsMode_1 = __importDefault(require("../../../templates/ToolsMode"));
const providers_1 = require("../../../providers");
const ui_1 = require("@completeanatomy/ui");
const i18n_1 = require("@completeanatomy/i18n");
const animation_1 = require("../../../utils/animation");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const bridge_1 = require("@completeanatomy/bridge");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const hooks_1 = require("../../../hooks");
// eslint-disable-next-line max-lines-per-function
function ToolPenModePage({ type = bridge_schema_1.ToolType.Pen2D }) {
    var _a, _b, _c;
    const [isUIHidden, toggleUIHidden] = (0, ui_1.useToggleState)(false);
    const [{ isGuidesAvailable, isGuidesExpanded }] = (0, providers_1.useGuidesContext)();
    const penOptions = (0, hooks_1.usePenOptions)();
    const toolsService = (0, providers_1.useToolsService)();
    const penManager = toolsService === null || toolsService === void 0 ? void 0 : toolsService.getPenToolManager();
    const curves = (0, hooks_1.usePen2DCurve)();
    const isGuidesButtonVisible = isGuidesAvailable && !isGuidesExpanded && !isUIHidden;
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const toolTypeFromURLParams = (_a = searchParams.get('type')) !== null && _a !== void 0 ? _a : '2d';
    const size = searchParams.get('size') !== null
        ? Number(searchParams.get('size'))
        : penOptions.size;
    const color = (_c = (_b = searchParams.get('color')) !== null && _b !== void 0 ? _b : penOptions.color) !== null && _c !== void 0 ? _c : '229,51,157';
    const opacity = searchParams.get('opacity') !== null
        ? Number(searchParams.get('opacity'))
        : penOptions.opacity;
    const bridge = (0, bridge_1.useBridge)();
    const savedPenType = sessionStorage.getItem('penType');
    const [penType, setPenType] = (0, react_1.useState)(() => {
        if (savedPenType) {
            return savedPenType === '3d' ? bridge_schema_1.ToolType.Pen3D : bridge_schema_1.ToolType.Pen2D;
        }
        if (type) {
            return type;
        }
        switch (toolTypeFromURLParams) {
            case '3d':
                return bridge_schema_1.ToolType.Pen3D;
            case '2d':
                return bridge_schema_1.ToolType.Pen2D;
            default:
                return type;
        }
    });
    (0, react_1.useEffect)(() => {
        if (penType === bridge_schema_1.ToolType.Pen3D) {
            const currentOptions = {
                type: bridge_schema_1.ToolType.Pen3D,
                opacity: penOptions.opacity !== undefined ? (1 - penOptions.opacity) * 100 : 0,
                sizeIndex: penOptions.size !== undefined ? 4 - penOptions.size : 3,
                color: penOptions.color !== undefined
                    ? penOptions.color.split(',').map(Number)
                    : [229, 51, 157],
            };
            bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
                type: bridge_schema_1.ToolType.Pen3D,
                currentOptions,
            });
        }
        else {
            const currentOptions = {
                type: bridge_schema_1.ToolType.Pen2D,
                size: size,
                color: color.split(',').map(Number),
                opacity: opacity || 1,
            };
            bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
                type: bridge_schema_1.ToolType.Pen2D,
                currentOptions,
            });
        }
        return () => {
            bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
                type: bridge_schema_1.ToolType.None,
                currentOptions: {
                    type: bridge_schema_1.ToolType.None,
                },
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bridge, toolTypeFromURLParams, penType]);
    const onClear = () => {
        if (penType === bridge_schema_1.ToolType.Pen2D) {
            penManager === null || penManager === void 0 ? void 0 : penManager.update2DPenState([]);
            penManager === null || penManager === void 0 ? void 0 : penManager.updateUndoRedoHistory();
        }
    };
    return ((0, jsx_runtime_1.jsxs)(ToolsMode_1.default, { title: penType === bridge_schema_1.ToolType.Pen2D
            ? (0, i18n_1.Localized)(i18n_1.Strings.tools.pen.title2d)
            : (0, i18n_1.Localized)(i18n_1.Strings.tools.pen.title3d), clearTitle: penType === bridge_schema_1.ToolType.Pen2D
            ? (0, i18n_1.Localized)(i18n_1.Strings.tools.pen.clear2d)
            : (0, i18n_1.Localized)(i18n_1.Strings.tools.pen.clear3d), onToggleUI: toggleUIHidden, selectedType: penType, onClear: onClear, isClearActive: penType === bridge_schema_1.ToolType.Pen2D && curves.length > 0, "data-e2e": 'ToolPenModePage_ToolsModeTemplate', children: [(0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isGuidesButtonVisible, timeout: 300, mountOnEnter: true, unmountOnExit: true, appear: true, "data-e2e": 'ToolPenModePage_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledGuidesButton, { "data-e2e": 'ToolPenModePage_StyledGuidesButton' }) }), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: !isUIHidden, timeout: 300, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'ToolPenModePage_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledToolsPenTypesPanel, { type: penType, onChange: setPenType, "data-e2e": 'ToolPenModePage_StyledToolsPenTypesPanel' }) }), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: !isUIHidden, timeout: 300, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'ToolPenModePage_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledToolsPenOptionsPanel, { initialType: penType, initialColor: color, initialSize: size, initialOpacity: opacity || 1, "data-e2e": 'ToolPenModePage_StyledToolsPenOptionsPanel' }) })] }));
}
exports.default = ToolPenModePage;
const StyledToolsPenTypesPanel = (0, styled_components_1.default)(PenTypesPanel_1.default) `
  position: absolute;

  bottom: 0;
  left: 0;

  ${(0, animation_1.SlideDown)('130%')}
`;
const StyledToolsPenOptionsPanel = (0, styled_components_1.default)(PenOptions_1.default) `
  position: absolute;
  bottom: 20px;
  left: calc(50% - 25px);

  ${(0, animation_1.SlideDown)('130%')}
`;
const StyledGuidesButton = (0, styled_components_1.default)(GuidesButton_1.default) `
  position: absolute;
  bottom: 160px;
  left: 20px;

  ${(0, animation_1.SlideLeft)('130%')}
`;
